<template>
  <div class="layout">
    <div class="tabScrollArea"
         :class="{ tabBgWhite: active==='home' && HNewGameUIConfig.newGameUIType===0 }"
         :style="{
      paddingBottom: hdi.channelFlag==='main'?'50px':'0',
    }
    ">
      <router-view v-slot="{ Component }">
        <keep-alive>
          <component :is="Component"/>
        </keep-alive>
      </router-view>
    </div>

    <van-tabbar v-if="HNewGameUIConfig.newGameUIType === 0" ref="tabBarRef" safe-area-inset-bottom v-model="active"
                @change="tabChange"
                active-color="#6B7FF7FF"
                inactive-color="#5C6293">
      <van-tabbar-item name="home">
        首页
        <template #icon="props">
          <img :src="props.active ? home_p : home_n" alt=""/>
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="reward" :dot="hasClaimableActivity">
        福利
        <template #icon="props">
          <img :src="props.active ? discount_p : discount_n" alt=""/>
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="recharge">
        充值
        <template #icon="props">
          <img :src="props.active ? pay_p : pay_n" alt=""/>
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="bet-his">
        注单
        <template #icon="props">
          <img :src="props.active ? betHistory_p : betHistory_n" alt=""/>
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="my">
        我的
        <template #icon="props">
          <img :src="props.active ? my_p : my_n" alt=""/>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>


<script setup>
  import home_n from '@/assets/icons/tabs/home_n.png';
  import home_p from '@/assets/icons/tabs/home_p.png';
  import discount_n from '@/assets/icons/tabs/preferential_n.png';
  import discount_p from '@/assets/icons/tabs/preferential_p.png';
  import pay_n from '@/assets/icons/tabs/pay_n.png';
  import pay_p from '@/assets/icons/tabs/pay_p.png';
  import betHistory_n from '@/assets/icons/tabs/bethistory_n.png';
  import betHistory_p from '@/assets/icons/tabs/bethistory_p.png';
  import my_n from '@/assets/icons/tabs/my_n.png';
  import my_p from '@/assets/icons/tabs/my_p.png';
  import {useRoute} from "vue-router";
  import {hr} from "@/components/utils/HRouter.js";
  import {useUserStore} from "@/stores/useUser.js";
  import {emitter} from "@/components/utils/HComFunctions.js";
  import {hdi} from "@/components/utils/HDeviceInfo.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  import {useHComApi} from "@/hooks/useHComApi.js";

  const {hasClaimableActivity} = useHComApi();

  let route = useRoute();
  const active = computed(() => route.name || 'home');

  function tabChange(name) {
    window.scrollTo({
      top: -10,
    });
    if (!useUserStore().isLogin && ["reward", "recharge", "bet-his"].includes(name)) {
      hr.go("login");
    } else {
      hr.go(name);
    }
  }

  const tabBarRef = ref(null);

  onMounted(() => {
    const el = tabBarRef.value?.$el;
    if (el) {
      el.addEventListener('dblclick', (e) => {
        e.preventDefault();
      });
    }
    // 暂时刷新必须从Home进入
    // active.value = route.name;
    emitter.on("HOME_BOTTOM_TAB_CHANGE", (tabIndex) => {
      switch (tabIndex) {
        case 0:
          tabChange("home");
          break;
        case 1:
          tabChange("reward");
          break;
        case 2:
          tabChange("recharge");
          break;
        case 3:
          tabChange("bet-his");
          break;
        case 4:
          tabChange("my");
          break;
      }
    });
  });

</script>


<style scoped>
  .layout {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden; /* 锁住整页, 让滚动只发生在内部容器, 顶部不被整体拖动 */
  }

  /* tab 内容区: 唯一的滚动容器。首页内容正好填满则不滚(顶部固定, 仅游戏区内部滚动);
     其它较长的 tab 页在此容器内滚动, 而不是滚动整个 body。 */
  .tabScrollArea {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }

  /* 永利首页: 底部给 tabbar 预留的 padding 区填白, 与游戏区白色连成一片, 不露底色 */
  .tabBgWhite {
    background-color: #fff;
  }
</style>
